import styled from "styled-components";

export const Container = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  strong {
    display: flex;
    justify-content: center;
    font-size: 2rem;
    margin-top: -18px;
    text-align: center;
  }
  p {
    display: flex;
    justify-content: center;
    text-align: center;
  }
`;
